import { createAxiosInstance } from './createAxiosInstance';

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const axiosRequest = createAxiosInstance(BASE_URL);
export const axiosRequestEvents = createAxiosInstance(process.env.REACT_APP_BASE_URL_EVENTS);
export const axiosRequestV2 = createAxiosInstance(process.env.REACT_APP_BASE_URL_V2);